<template>
    <div>
        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            <h6 class="card-title">登記情報</h6>

            <form
                @submit.prevent="saveProfile"
                >

                <UserProfileContent
                    v-model="modelUser.profile"
                    :error="error.profile"
                    />

                <p class="mt-3">
                    社名変更、住所変更等によって登記情報が変更になる場合は変更依頼を出してください。
                    <br>
                    登記情報は損害保険ジャパンにも提出される情報ですので変更依頼後に弊社もしくは損害保険ジャパンにて確認させていただいた上で承認をさせていただきます。
                    <br>
                    登記簿のご提出をお願いする場合もございます。
                </p>

                <p
                    class="text-danger"
                    v-if="modelUser.approval && modelUser.approval.type === 'profile'"
                    >
                    ※変更を管理者が承認するまでお待ちください。
                </p>

                <div class="text-right mt-3">
                    <button type="submit" class="btn btn-theme">変更依頼</button>
                </div>
            </form>
        </b-card>

        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            <h6 class="card-title">アカウント名</h6>

            <form
                @submit.prevent="saveNickname"
                >
                <b-form-input
                    v-model="modelUser.nickname"
                    type="text"
                    placeholder=""
                    >
                </b-form-input>
                <input-error :errors="error.nickname" />

                <p class="mt-3">
                    Tuskeyアカウントを区別するためのニックネームを自由に設定できます。
                    <br>
                    Tuskeyアカウントを複数所持する方が利用します。
                </p>

                <div class="text-right mt-3">
                    <button type="submit" class="btn btn-theme">変更</button>
                </div>
            </form>
        </b-card>

        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            <h6 class="card-title">認証情報</h6>

            <form
                @submit.prevent="saveEmail"
                >
                <b-form-group
                    label-cols-sm="2"
                    label="メールアドレス"
                    label-size="sm"
                    @submit.stop.prevent
                    >
<template v-if="! email_new">
                    <b-form-input
                        v-model="modelUser.email"
                        type="email"
                        placeholder="your@email.com"
                        >
                    </b-form-input>
                    <input-error :errors="error.email" />
                    <input-error :errors="error.onetime_password_value" />

                    <div class="text-right mt-3">
                        <button type="submit" class="btn btn-theme">変更</button>
                    </div>
</template>

<template v-if="email_new">
                    <span>メールで届いた認証コード</span>
                    <b-form-input
                        v-model="modelUser.onetime_password"
                        type="text"
                        placeholder="123456"
                        @input="saveEmail"
                        >
                    </b-form-input>
                    <input-error :errors="error.email" />
                    <input-error :errors="error.onetime_password" />

                    <div class="text-right mt-3">
                        <b-link @click="step1">再送信</b-link>
                    </div>
</template>
                </b-form-group>
            </form>
        </b-card>

        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            <h6 class="card-title">セッション</h6>

            <b-form-group
                label-cols-sm="2"
                label-size="sm"
                @submit.stop.prevent
                >
                <div class="text-right mt-3">
                    <b-button variant="danger" @click="logout">ログアウト</b-button>
                </div>
            </b-form-group>
        </b-card>

<template v-if="auth_level >= 300">
        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            <h6 class="card-title">APIキー</h6>

            <b-form-group
                label-cols-sm="2"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-form-input
                    v-model="modelUser.api_token"
                    placeholder="未設定"
                    readonly
                    >
                </b-form-input>

                <div class="text-right mt-3">
                    <b-button
                        class="px-4 lh-1 btn-theme"
                        @click="setApiToken('generate')">
                        生成
                    </b-button>

                    <b-button
                        class="px-4 lh-1 btn-danger"
                        @click="setApiToken('reset')">
                        削除
                    </b-button>
                </div>
            </b-form-group>
        </b-card>
</template>

        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            <h6 class="card-title">外部連携</h6>

            <b-form-group
                label-cols-sm="2"
                label="Amazon"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.inventories" />
                        <UserSettingInfo :model="modelInventories.amazon" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="2"
                label="AmazonAu"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.inventories" />
                        <UserSettingInfo :model="modelInventories.amazon_au" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="2"
                label="AmazonCa"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.inventories" />
                        <UserSettingInfo :model="modelInventories.amazon_ca" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="2"
                label="eBay"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.stores" />
                        <UserSettingInfo :model="modelStores.ebay" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>
<!--
            <b-form-group
                label-cols-sm="2"
                label="eBayAu"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.stores" />
                        <UserSettingInfo :model="modelStores.ebay_au" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>
-->
            <b-form-group
                label-cols-sm="2"
                label="DHL"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.shippings" />
                        <UserSettingInfo :model="modelShippings.dhl" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>
<div v-show="auth_level >= 300">

            <b-form-group
                label-cols-sm="2"
                label="WooCommerce"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.stores" />
                        <UserSettingInfo :model="modelStores.woo" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="2"
                label="UPS"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.stores" />
                        <UserSettingInfo :model="modelShippings.ups" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>

            <hr class="my-5">

            <b-form-group
                label-cols-sm="2"
                label="候補更新（SKU指定）"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <div class="mb-2">
                            <b-form-textarea
                                placeholder="sku(改行区切)"
                                rows="3"
                                max-rows="30"
                                v-model="skus_by_line"
                                ></b-form-textarea>
                            <input-error :errors="error.skus" />
                        </div>
                        <div class="text-right">
                            <b-button
                                size="sm"
                                class="px-4 lh-1 btn-theme"
                                @click="syncBySkus"
                                >
                                <small>
                                    <strong>
                                        候補更新
                                        <br>
                                        <font-awesome-icon
                                            class="fa-fw"
                                            icon="sync"
                                            />
                                    </strong>
                                </small>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form-group>
</div>
        </b-card>

        <a @click="show_test=true">.&emsp;.</a>
        <b-card
            class="mt-3"
            body-class="mt-3"
            v-if="auth_level >= 300 && show_test"
            >
            <h6 class="card-title">テスト</h6>

            <strong>17track</strong>

            <b-form-group
                label-cols-sm="4"
                label="17track:shipping_log"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="test17track">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <strong>DHL</strong>

            <b-form-group
                label-cols-sm="4"
                label="DHL:label"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testDhlLabel">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <strong>woo</strong>

            <b-form-group
                label-cols-sm="4"
                label="woo:copyItem"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testWooCopyItem">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="woo:updateProduct"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testWooUpdateProduct">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>


            <hr class="my-5">

            <strong>ebay</strong>

            <b-form-group
                label-cols-sm="4"
                label="FBA出荷依頼（手動）"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <div class="mb-2">
                            <b-form-input
                                placeholder="eBay注文番号"
                                v-model="ebay_order_id"
                                />
                            <input-error :errors="error.ebay_order_id" />
                        </div>
                        <div class="text-right">
                            <b-button
                                size="sm"
                                class="px-4 lh-1 btn-theme"
                                @click="askFbaToShipByEbayOrderId"
                                >
                                出荷依頼
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayEndItem"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <div class="mb-2">
                            <b-form-input
                                placeholder="eBay item_id"
                                v-model="test.ebay.item_id"
                                />
                            <input-error :errors="error.ebay_item_id" />
                        </div>
                        <div class="text-right">
                            <b-button
                                size="sm"
                                class="px-4 lh-1 btn-danger"
                                @click="testEbayEndItem"
                                >
                                終了
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayRelistItem"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <div class="mb-2">
                            <b-form-input
                                placeholder="eBay item_id"
                                v-model="test.ebay.item_id"
                                />
                            <input-error :errors="error.ebay_item_id" />
                        </div>
                        <div class="text-right">
                            <b-button
                                size="sm"
                                class="px-4 lh-1 btn-danger"
                                @click="testEbayRelistItem"
                                >
                                再出品
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetItem"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <div class="mb-2">
                            <b-form-input
                                placeholder="eBay item_id"
                                v-model="test.ebay.item_id"
                                />
                            <input-error :errors="error.ebay_item_id" />
                        </div>
                        <div class="text-right">
                            <b-button
                                size="sm"
                                class="px-4 lh-1 btn-theme"
                                @click="testEbayGetItem"
                                >
                                取得
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetInventoryItem"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <div class="mb-2">
                            <b-form-input
                                placeholder="eBay sku"
                                v-model="test.ebay.item_id"
                                />
                            <input-error :errors="error.ebay_item_id" />
                        </div>
                        <div class="text-right">
                            <b-button
                                size="sm"
                                class="px-4 lh-1 btn-theme"
                                @click="testEbayGetInventoryItem"
                                >
                                取得
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayAddFixedPriceItem"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-danger" @click="testEbayAddFixedPriceItem">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGeteBayDetails"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGeteBayDetails">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetCategoryFeatures"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetCategoryFeatures">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetItemAspectsForCategory"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <input type="number" class="form-control" v-model="test.ebay.category_id">
                        <button class="btn btn-theme" @click="testEbayGetItemAspectsForCategory">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetCategories"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetCategories">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetFulfillmentPolicy"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetFulfillmentPolicy">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetPaymentPolicy"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetPaymentPolicy">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetReturnPolicy"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetReturnPolicy">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetItemConditionPolicies"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <input type="number" class="form-control" v-model="test.ebay.category_id">
                        <button class="btn btn-theme" @click="testEbayGetItemConditionPolicies">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetRateLimits"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetRateLimits">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayListenMyMessageseBayMessage"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-danger" @click="testEbayListenMyMessageseBayMessage">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayCreateAShippingFulfillment"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-danger" @click="testEbayCreateAShippingFulfillment">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetShippingFulfillments"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetShippingFulfillments">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayGetOrder"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <input type="text" class="form-control" v-model="test.ebay.order_id">
                        <button class="btn btn-theme" @click="testEbayGetOrder">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:testEbayListenFixedPriceTransaction"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-danger" @click="testEbayListenFixedPriceTransaction">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:getUser"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetUser">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:setNotifications"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbaySetNotificationItemSold">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:getNotifications"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetNotifications">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:getNotificationsUsage"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetNotificationsUsage">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="ebay:getItemSalesSearch"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testEbayGetItemSalesSearch">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <strong>amazon</strong>
            <b-form-group
                label-cols-sm="4"
                label="amazon:sqs/recieveMessage"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testAmazonSqsRecieveMessage">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:registerSqsRecieveMessageAll"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testAmazonRegisterSqsRecieveMessageAll">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:notifications/getSubscription"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testAmazonNotificationsGetSubscription">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:notifications/createSubscription"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <input type="text" class="form-control" v-model="test.amazon.destination_id">
                        <button class="btn btn-theme" @click="testAmazonNotificationsCreateSubscription">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:notifications/deleteSubscription"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <input type="text" class="form-control" v-model="test.amazon.subscription_id">
                        <button class="btn btn-danger" @click="testAmazonNotificationsDeleteSubscription">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:notifications/getDestinations"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testAmazonNotificationsGetDestinations">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:notifications/createDestination"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testAmazonNotificationsCreateDestination">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:notifications/deleteDestination"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <input type="text" class="form-control" v-model="test.amazon.destination_id">
                        <button class="btn btn-danger" @click="testAmazonNotificationsDeleteDestination">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:createSubscriptionFulfillmentOrderStatus"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testAmazonCreateSubscriptionFulfillmentOrderStatus">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:getFulfillmentOrder"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <input type="text" class="form-control" v-model="test.amazon.order_id">
                        <button class="btn btn-theme" @click="testAmazonGetFulfillmentOrder">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:getInventorySummaries"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testAmazonGetInventorySummaries">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:getUser"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testAmazonGetUser">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:createFulfillmentOrder"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-danger" @click="testAmazonCreateFulfillmentOrder">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="amazon:cancelFulfillmentOrder"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-danger" @click="testAmazonCancelFulfillmentOrder">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <strong>crobo</strong>
            <b-form-group
                label-cols-sm="4"
                label="testCroboOrderSearch"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testCroboOrderSearch">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="4"
                label="testCroboOrderGet"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col class="text-right mt-3">
                        <button class="btn btn-theme" @click="testCroboOrderGet">実行</button>
                    </b-col>
                </b-row>
            </b-form-group>
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        </b-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import UserSettingInfo from '@/components/UserSettingInfo.vue'
import InsuranceTable from '@/components/InsuranceTable.vue'
import UserProfileContent from '@/components/UserProfileContent.vue'

export default {
    components: {
        GridPage,
        Item,
        ItemBadges,
        ItemThumb,
        UserSettingInfo,
        InsuranceTable,
        UserProfileContent,
    },
    props: {
//        user_uuid: {
//            type: String,
//            required: true,
//            default() {
//                return null
//            },
//        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'auth_email',
            'trans',
        ])
    },
    data() {
        return {
            modelUser: {
                profile: {},
            },
            modelInventories: {
            },
            modelStores: {
            },
            modelShippings: {
            },
            skus_by_line: '',
            ebay_order_id: '',
            error: {
            },
            timer: null,
            email_new: null,
            is_loaded: false,

            show_test: false,
            test: {
                ebay: {
                    category_id: '',
                    order_id: '',
                    item_id: '187430011876',
                },
                amazon: {
                    order_id: '',
                    destination_id: '',
                    subscription_id: '',
                },
            },
        }
    },
    watch: {
        $route: {
            async handler () {
            },
            immediate: true
        }
    },
    mounted() {
        this.step1()

        this.timer = setInterval(this.fetch, 30 * 1000)
//this.$refs.table.getData()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        async fetch () {
            const response = await this.$store
                .dispatch('auth/me', { SILENT: true, })
                .then((response) => {
                    this.modelInventories = response.data.data.settings.inventories || {}
                    this.modelStores = response.data.data.settings.stores || {}
                    this.modelShippings = response.data.data.settings.shippings || {}

                    // filter
                    this.$set(this.modelInventories, 'amazon', this.modelInventories.amazon || { provider: 'amazon', })
                    this.$set(this.modelInventories, 'amazon_au', this.modelInventories.amazon_au || { provider: 'amazon_au', })
                    this.$set(this.modelInventories, 'amazon_ca', this.modelInventories.amazon_ca || { provider: 'amazon_ca', })
                    this.$set(this.modelStores, 'ebay', this.modelStores.ebay || { provider: 'ebay', })
                    this.$set(this.modelStores, 'ebay_au', this.modelStores.ebay_au || { provider: 'ebay_au', })
                    this.$set(this.modelStores, 'ebay_ca', this.modelStores.ebay_ca || { provider: 'ebay_ca', })
                    this.$set(this.modelStores, 'woo', this.modelStores.woo || { provider: 'woo', url: null, ck: null, cs: null, ver: null, })
                    this.$set(this.modelShippings, 'dhl', this.modelShippings.dhl || { provider: 'dhl', url: null, ck: null, cs: null, ver: null, })
                    this.$set(this.modelShippings, 'ups', this.modelShippings.ups || { provider: 'ups', url: null, ck: null, cs: null, ver: null, })

                    // table
                    if (!this.is_loaded) {
                        this.modelUser = response.data.data || {}

//                        let profile = this.modelUser.profile
//                        if (!Array.isArray(profile)) {
//                            profile = [{}]
//                        }
//                        this.$refs.table.loadData(profile)
                    }
                    this.is_loaded = true

                })
                .catch((error) => {
                })
        },
        async saveNickname () {
            this.error = {}

            await this.$store
                .dispatch('auth/nickname', {
                    nickname: this.modelUser.nickname,
                })
                .then((response) => {
                    this.is_loaded = false
                    this.fetch()
                })
                .catch((error) => {
                    this.error = error
                })
        },
        async saveEmail () {
            if (! this.email_new) {
                await this.$store
                    .dispatch('auth/ready', {
                        email: this.auth_email,
                        onetime_password_type: 'email',
                        onetime_password_value: this.modelUser.email,
                    })
                    .then((response) => {
                        this.email_new = this.modelUser.email
//                        this.step1()
                    })
                    .catch((error) => {
                        this.error = error
                    })
            } else {
                if ((this.modelUser.onetime_password || '').length != 6) {
                    return
                }

                await this.$store
                    .dispatch('auth/email', {
                        onetime_password: this.modelUser.onetime_password,
                    })
                    .then((response) => {
                        this.step1()
                    })
                    .catch((error) => {
                        this.error = error
                    })
            }
        },
        async saveProfile () {
            this.error = {}
            await this.$store
                .dispatch('auth/profile', {
                    profile: this.modelUser.profile,//this.$refs.table.getData(),
                })
                .then((response) => {
                    this.is_loaded = false
                    this.fetch()
                })
                .catch((error) => {
                    this.$utils.set(this.error, { profile: error, })
                })
        },
        async saveWoo () {
            await this.$store
                .dispatch('store/save', this.modelStores.woo)
                .then((response) => {
//                    this.fetch()
//                    this.$emit('sync')
                })
                .catch((error) => {
                })
        },
        async syncBySkus () {
            this.error = Object.assign({})

            let skus = this.skus_by_line
                .split('\n')
                .map((v) => { return v.trim() })
                .filter((v) => { return v !== '' })
            // unique
            skus = [...new Set(skus)]
            await this.$store
                .dispatch('item_cache/sync_by_skus', {
                    skus: skus,
                })
                .then((response) => {
                    this.skus_by_line = ''
//                    this.fetch()
//                    this.$emit('sync')
                })
                .catch((error) => {
                    this.error = error
                })
        },
        async askFbaToShipByEbayOrderId() {
            this.error = Object.assign({})

            await this.$store
                .dispatch('item_cache/ask_fba_to_ship_by_ebay_order_id', {
                    ebay_order_id: this.ebay_order_id,
                })
                .then((response) => {
                    this.ebay_order_id = ''
//                    this.fetch()
//                    this.$emit('sync')
                })
                .catch((error) => {
                    this.error = error
                })
        },
        async logout() {
            this.$store.dispatch('auth/logout')
        },
        step1 () {
            this.fetch().then(() => {
                this.email_new = null
//                this.$set(this.modelUser, 'email_new', null)
            })

            this.error = Object.assign({})
        },
        async setApiToken(type) {
            this.$store.dispatch('auth/api_token', type)
                .then((response) => {
                    this.is_loaded = false
                    this.fetch()
//                    this.step1()
                })
                .catch((error) => {
                    this.is_loaded = false
                    this.fetch()
                })
        },

///////////////////////////////////////////////////
// test
///////////////////////////////////////////////////
        async testWooCopyItem () {
            axios
                .post('/api/v1/test/wooCopyItem', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testWooUpdateProduct () {
            axios
                .put('/api/v1/test/wooUpdateProduct', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayEndItem () {
            axios
                .post('/api/v1/test/ebayEndItem', {
                    item_id: this.test.ebay.item_id,
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayRelistItem () {
            axios
                .post('/api/v1/test/ebayRelistItem', {
                    item_id: this.test.ebay.item_id,
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetItem () {
            axios
                .get('/api/v1/test/ebayGetItem', {
                    params: {
                        item_id: this.test.ebay.item_id,
                    },
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetInventoryItem () {
            axios
                .get('/api/v1/test/ebayGetInventoryItem', {
                    params: {
                        sku: this.test.ebay.item_id,
                    },
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayAddFixedPriceItem () {
            axios
                .post('/api/v1/test/ebayAddFixedPriceItem', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGeteBayDetails () {
            axios
                .get('/api/v1/test/ebayGeteBayDetails', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetCategoryFeatures () {
            axios
                .get('/api/v1/test/ebayGetCategoryFeatures', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetCategories () {
            axios
                .get('/api/v1/test/ebayGetCategories', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetItemAspectsForCategory () {
            axios
                .get('/api/v1/test/ebayGetItemAspectsForCategory', {
                    params: {
                        category_id: this.test.ebay.category_id,
                    },
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetFulfillmentPolicy () {
            axios
                .get('/api/v1/test/ebayGetFulfillmentPolicy', {
                    params: {
                    },
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetPaymentPolicy () {
            axios
                .get('/api/v1/test/ebayGetPaymentPolicy', {
                    params: {
                    },
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetReturnPolicy () {
            axios
                .get('/api/v1/test/ebayGetReturnPolicy', {
                    params: {
                    },
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetItemConditionPolicies () {
            axios
                .get('/api/v1/test/ebayGetItemConditionPolicies', {
                    params: {
                        category_id: this.test.ebay.category_id,
                    },
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetRateLimits () {
            axios
                .get('/api/v1/test/ebayGetRateLimits', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayCreateAShippingFulfillment () {
            axios
                .post('/api/v1/test/ebayCreateAShippingFulfillment', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetShippingFulfillments () {
            axios
                .get('/api/v1/test/ebayGetShippingFulfillments', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetOrder () {
            axios
                .get('/api/v1/test/ebayGetOrder', {
                    params: {
                        order_id: this.test.ebay.order_id,
                    },
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayListenMyMessageseBayMessage () {
            axios
                .post('/api/v1/test/ebayListenMyMessageseBayMessage', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayListenFixedPriceTransaction () {
            axios
                .post('/api/v1/test/ebayListenFixedPriceTransaction', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetUser () {
            axios
                .get('/api/v1/test/ebayGetUser', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbaySetNotificationItemSold () {
            axios
                .post('/api/v1/test/ebaySetNotificationItemSold', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetNotifications () {
            axios
                .get('/api/v1/test/ebayGetNotifications', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetNotificationsUsage () {
            axios
                .get('/api/v1/test/ebayGetNotificationsUsage', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testEbayGetItemSalesSearch () {
            axios
                .get('/api/v1/test/ebayGetItemSalesSearch', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonSqsRecieveMessage () {
            axios
                .get('/api/v1/test/amazonSqsRecieveMessage', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonNotificationsGetSubscription () {
            this.test.amazon.subscription_id = '';
            axios
                .get('/api/v1/test/amazonNotificationsGetSubscription', {
                })
                .then((response) => {
                    this.test.amazon.subscription_id = response.data.payload.subscriptionId;
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonNotificationsCreateSubscription () {
            axios
                .post('/api/v1/test/amazonNotificationsCreateSubscription/ORDER_CHANGE', {
                    payload_version: '1.0',
                    destination_id: this.test.amazon.destination_id,
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonNotificationsDeleteSubscription () {
            axios
                .delete('/api/v1/test/amazonNotificationsDeleteSubscription/' + this.test.amazon.subscription_id, {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonNotificationsGetDestinations () {
            this.test.amazon.destination_id = '';
            axios
                .get('/api/v1/test/amazonNotificationsGetDestinations', {
                })
                .then((response) => {
                    for (let i = 0; i < (response.data.payload || []).length; i++) {
                        const dest = (response.data.payload || [])[i];
                        this.test.amazon.destination_id = dest.destinationId;
                    }
                    return response;
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonNotificationsCreateDestination () {
            axios
                .post('/api/v1/test/amazonNotificationsCreateDestination', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonNotificationsDeleteDestination () {
            axios
                .delete('/api/v1/test/amazonNotificationsDeleteDestination/' + this.test.amazon.destination_id, {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },

        async testAmazonCreateSubscriptionFulfillmentOrderStatus () {
            axios
                .post('/api/v1/test/amazonCreateSubscriptionFulfillmentOrderStatus', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonGetFulfillmentOrder () {
            axios
                .get('/api/v1/test/amazonGetFulfillmentOrder', {
                    params: {
                        order_id: this.test.amazon.order_id,
                    },
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonGetInventorySummaries () {
            axios
                .get('/api/v1/test/amazonGetInventorySummaries', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonGetUser () {
            axios
                .get('/api/v1/test/amazonGetUser', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonCreateFulfillmentOrder () {
            axios
                .post('/api/v1/test/amazonCreateFulfillmentOrder', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonCancelFulfillmentOrder () {
            axios
                .post('/api/v1/test/amazonCancelFulfillmentOrder', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testAmazonRegisterSqsRecieveMessageAll () {
            axios
                .post('/api/v1/test/amazonRegisterSqsRecieveMessageAll', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testDhlLabel () {
            let data = {}
            data = Object.assign(data, { download: true, })
            const response =
                await axios.get('/api/v1/test/dhlLabel', {
                    params: (typeof data === 'object' ? data : null),
                    responseType: 'blob',
                    dataType: 'binary',
                    headers: { 'Cache-Control': 'no-cache' },
                })
                .catch(error => error.response || null)
            this.download(response)
//            Vue.prototype.download(response)
            return response

            axios
                .post('/api/v1/test/dhlLabel', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async test17track () {
            axios
                .post('/api/v1/test/sync17track', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testCroboOrderGet () {
            axios
                .get('/api/v1/test/croboOrderGet', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async testCroboOrderSearch () {
            axios
                .get('/api/v1/test/croboOrderSearch', {
                })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    return Promise.reject(error.response.data.errors || {})
                })
        },
    },
}
</script>

